export enum QuizEstiloDeVidaRespostaEnum {
  NUNCA = 0,
  RARAMENTE = 1,
  QUASE_SEMPRE = 2,
  SEMPRE = 3,
}

const descricao = new Map<QuizEstiloDeVidaRespostaEnum, string>([
  [QuizEstiloDeVidaRespostaEnum.NUNCA, 'Nunca'],
  [QuizEstiloDeVidaRespostaEnum.RARAMENTE, 'Raramente'],
  [QuizEstiloDeVidaRespostaEnum.QUASE_SEMPRE, 'Quase Sempre'],
  [QuizEstiloDeVidaRespostaEnum.SEMPRE, 'Sempre'],
]);

export class QuizEstiloDeVidaRespostaEnumDescription {
  static getDescricao(valor: QuizEstiloDeVidaRespostaEnum): string {
    return descricao.get(valor) || '';
  }

  static getAll(): { valor: QuizEstiloDeVidaRespostaEnum; descricao: string }[] {
    return Array.from(descricao.entries()).map(([valor, descricao]) => ({
      valor,
      descricao,
    }));
  }
}
